import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import AutoComplete from '../Common/AutoComplete';
import SkillActions from '../../actions/SkillActionCreator';
import SearchStore from '../../stores/SearchStore';
import MenuItem from 'material-ui/MenuItem';

class SelectSkill extends Component {

    componentDidMount() {
        this.onUpdate = this.onUpdate.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    render() {
        const { items, searchText } = this.state;
        const match = searchText ? new RegExp(searchText, 'i') : {test: () => false};
        const data = items && items.filter(({name}) => name && match.test(name))
            .map(({id, name}) => ({
                id,
                text: name,
                value: <MenuItem key={id} value={id} primaryText={name} />
            }));

        return (
            <AutoComplete
                searchText={searchText}
                floatingLabelText={this.props.label}
                maxSearchResults={5}
                dataSource={data}
                onUpdateInput={this.onUpdate}
                onNewRequest={this.onSelect}
                fullWidth={true}
            />
        );
    }

    onUpdate(input) {
        this.timeout && clearTimeout(this.timeout);
        if (input !== undefined && input.length >= 2) {
            this.timeout = setTimeout(function() {
                SkillActions.search(input, {limit: 10});
            }.bind(this), 500);
        }
        this.setState({searchText: input || ''});
    }

    onSelect({id, text}) {
        this.props.onSelect(text, id);
        if (this.props.clearOnSelect) {
            this.setState({searchText: ''});
        }
    }
}

SelectSkill.propTypes = {
    clearOnSelect: PropTypes.bool,
    label: PropTypes.string,
    onSelect: PropTypes.func.isRequired
};

SelectSkill.defaultProps = {
    clearOnSelect: true,
    label: 'Add skill'
};

SelectSkill.getStores = () => ([SearchStore]);
SelectSkill.calculateState = (prevState) => ({
    searchText: (prevState && prevState.searchText) || '',
    items: SearchStore.getResults() || []
});

export default Container.create(SelectSkill);
